// extracted by mini-css-extract-plugin
export default {"color":"HomePersonalizationAttachmentsPanel_color__eUW41"};